import { createSelector } from 'reselect'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import getIdReduxUtil from 'modules/redux/utils/get-id'

const getCurrentIdTrainingUserSelect = createSelector(
  getCurrentTrainingUserSelect,
  currentUser => getIdReduxUtil(currentUser)
)

export default getCurrentIdTrainingUserSelect
